import Prediction from './index.vue'

export default [
  {
    path: '/prediction',
    name: 'Prediction',
    component: Prediction
  }
]
